// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'ATM terminals'" tab="true"></sub-header>

  <branches-list detail-link="/#!/admin/atm-terminals"></branches-list>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/atm/branches/atm-terminal-branches.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;